// Klaviyo popups autofocus the email input on mobile, opening the keyboard; move initial focus to the close button.
const seenDialogs = new WeakSet();

document.addEventListener(
  'focusin',
  (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    const dialog = target.closest('[role="dialog"]');
    const closeButton = dialog?.querySelector('.klaviyo-close-form');
    if (!dialog || !(closeButton instanceof HTMLElement) || seenDialogs.has(dialog)) return;

    // Only the first focus after the popup opens is Klaviyo's autofocus
    seenDialogs.add(dialog);
    if (target instanceof HTMLInputElement && window.matchMedia('(pointer: coarse)').matches) {
      closeButton.focus({ preventScroll: true });
    }
  },
  true
);
